export default __webpack_public_path__ + "locales/pt/ChangePasswordDialog.json?hash=5e8845105b8656aa2d3836ae35b7f985";